// expects a str in the "YYYY-MM-DDTHH:mm:ssZ"
function getTimeFromZeroTimezoneDate(ISODateStr) {
  if (!ISODateStr) return '';
  if (ISODateStr.indexOf('T') < 0) return ISODateStr;
  const time = ISODateStr.split('T')[1];
  return time
    .split(':')
    .slice(0, 2)
    .join(':');
}

export default getTimeFromZeroTimezoneDate;
